import React from "react";
import compose from "recompose/compose";
import EnhanceProduct from "./EnhanceProduct";
import ProductQuery from "./ProductQuery.gql";
import withTrackPage from "theme/modules/Analytics/withTrackPage";
import Loadable from "theme/components/helpers/Loadable";
import Upsells from "theme/modules/ProductList/Upsells";
import ProductAddedPopIn from "theme/modules/ProductAddedPopIn";
import ProductSeo from "theme/modules/ProductView/ProductSeo";
import RelatedProducts from "theme/modules/ProductList/RelatedProducts";
import withProductTracking from "theme/modules/ProductView/withProductTracking";
import LoadingRoute from "theme/modules/Router/LoadingRoute";
import ProductBreadcrumb from "theme/modules/ProductView/ProductBreadcrumb/ProductBreadcrumb";
import ProductView from "theme/modules/ProductView";
import Stack from "theme/components/atoms/Layout/Stack";
import ProductDescription from "theme/modules/ProductView/ProductDescription";
import { hasDescription } from "theme/modules/ProductView/ProductDescription";
import usePublishProductReviewModal, {
  hasPublishProductReview,
} from "theme/modules/Reviews/PublishProductReview/usePublishProductReviewModal";
import {
  PRODUCT_VIEW_IMAGE_SIZES,
  PRODUCT_VIEW_THUMB_SIZES,
  RELATED_PRODUCTS_IMAGE_SIZES,
} from "./ProductConstants";
import StorefrontContent from "theme/modules/StorefrontContent";

const Product = (props) => {
  const [publishProductReviewModal] = usePublishProductReviewModal(
    props.product
  );

  return (
    <StorefrontContent type="Product" id={props.product.sku} scope="page">
      <div
        key={props.product.sku}
        itemScope
        itemType="http://schema.org/Product"
      >
        <ProductSeo product={props.product} />
        <ProductAddedPopIn
          product={props.productAdded}
          hidePopin={props.hidePopin}
        />

        <ProductBreadcrumb product={props.product} />

        <div className="page-content page-content--with-image-top-mobile">
          <Stack size="8">
            <ProductView
              product={props.product}
              onProductAdded={(product) => props.showPopin(product)}
              galleryImageSizes={{
                imageSizes: PRODUCT_VIEW_IMAGE_SIZES,
                thumbSizes: PRODUCT_VIEW_THUMB_SIZES,
              }}
            />
            {hasDescription(props.product) && (
              <div className="container">
                <ProductDescription product={props.product} />
              </div>
            )}
            {props.product.related && props.product.related.length > 0 && (
              <RelatedProducts
                products={props.product.related}
                imageSizes={RELATED_PRODUCTS_IMAGE_SIZES}
                prioritizeTop={0}
              />
            )}
            {props.product.upsells && props.product.upsells.length > 0 && (
              <Upsells
                loading={props.loading}
                products={props.product.upsells}
              />
            )}
          </Stack>
        </div>
      </div>
      {hasPublishProductReview(props.product)
        ? publishProductReviewModal
        : null}
    </StorefrontContent>
  );
};

export default compose(
  EnhanceProduct({
    ProductQuery,
  }),
  withTrackPage("Product"),
  Loadable((props) => !props.loading, LoadingRoute),
  withProductTracking()
)(Product);
